import React from 'react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { FaLongArrowAltRight } from "react-icons/fa";
import { Link } from 'react-router-dom';
import useTitle from '../../Hooks/useTitle';

const About = () => {
    useTitle("About");
    const bannerImage = 'https://i.ibb.co/hgygmvH/Shakil-AHamed.jpg';
    return (
        <div className='px-5 md:px-20 lg:px-32 pt-10 max-w-[1400px] m-auto'>
            <h1 className='text-4xl font-bold mb-10 text-center md:hidden lg:hidden'>About <span className='text-teal-300'>Me</span></h1>
            <div className='flex flex-col md:flex-row lg:flex-row items-center mb-32'>
                <div className='w-full md:w-1/2 lg:w-1/2 rounded-full mb-10 flex justify-center md:justify-between lg:justify-between' data-aos='fade-up'>
                    <PhotoProvider>
                        <PhotoView src={bannerImage}>
                            <img className='about-image rounded-full w-3/4 h-3/4' src={bannerImage} alt="" />
                        </PhotoView>
                    </PhotoProvider>
                </div>
                <div data-aos='fade-up' className='w-full md:w-1/2 lg:w-1/2'>
                    <h1 className='hidden md:block lg:block text-4xl font-bold mb-5 tracking-widest'>About <span className='text-teal-300'>Me</span></h1>
                    <h1 className='text-2xl font-bold'>Shakil Ahamed</h1>
                    <p className='text-sm font-bold mb-4'>Web & App Developer</p>
                    <p className='opacity-80'>I am twenty four years old. I am doing my
                        <span className='text-teal-100 font-bold'> B.Sc </span>
                        in
                        <span className='text-teal-100 font-bold'> Computer Science and Engineering (CSE) </span>
                        at
                        <span className='text-teal-100 font-bold'> Dhaka International University </span>
                        right now and I specialize in Web & App Development. I am working as a MERN Stack Developer for the 2+ years, and I have extensive experience with both front-end and back-end development. I have a deep interest in Web Development and I made some projects <Link to={'/projects'} className='text-cyan-300 hover:text-cyan-500'>see projects...</Link>
                    </p>

                    <Link to='/about'>
                        <button className='flex items-center btn btn-sm btn-outline text-teal-300 mt-5'>More About Me <FaLongArrowAltRight></FaLongArrowAltRight></button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default About;